import { Model } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';

import {
  DatasetResource,
  DefinitionResource,
  QueryResource,
  QueryResultResource,
  QueryRunResource,
  ReportRunResource,
} from '@mode/legacy/data-access-model-js';
import { SelectedDefinitionActionType } from '@mode/legacy/util-domain';

export { SelectedDefinitionActionType };

export enum DefinitionUpdateStrategy {
  SaveOnly = 'SaveOnly',
  SaveAndSync = 'SaveAndSync',
}

export type DefinitionUpdateStrategyTypes = DefinitionUpdateStrategy.SaveOnly | DefinitionUpdateStrategy.SaveAndSync;

export interface UpdateDefinitionAction {
  type: SelectedDefinitionActionType.UpdateDefinition;
  strategy: DefinitionUpdateStrategyTypes;
  commitMessage?: string;
}

export interface ManageDefinitionAction {
  type: SelectedDefinitionActionType.ManageDefinition;
  token: string;
  name: string;
  source: string;
  description: string;
  dataSourceId: string;
  modalConfirm?: (definition) => void; // Haven't figured out how modals should work in ngrx
}

export interface UpdateDefinitionSuccessAction {
  type: SelectedDefinitionActionType.UpdateDefinitionSuccess;
  definition: DefinitionResource;
  strategy: DefinitionUpdateStrategyTypes;
  commitMessage?: string;
}

export interface UpdateDefinitionFailedAction {
  type: SelectedDefinitionActionType.UpdateDefinitionFailed;
  token: string;
  strategy: DefinitionUpdateStrategyTypes;
  error: Error;
}

export interface PollDefinitionRunAction {
  type: SelectedDefinitionActionType.PollDefinitionRun;
  definitionModel: any;
}

export interface PollDefinitionRunFailedAction {
  type: SelectedDefinitionActionType.PollDefinitionRunFailed;
  error: Error;
}

export interface DeleteDefinitionAction {
  type: SelectedDefinitionActionType.DeleteDefinition;
}

export interface DeleteDefinitionSuccessAction {
  type: SelectedDefinitionActionType.DeleteDefinitionSuccess;
}

export interface DeleteDefinitionFailureAction {
  type: SelectedDefinitionActionType.DeleteDefinitionFailure;
  error: Error;
}

export interface ExecuteDefinitionRunAction {
  type: SelectedDefinitionActionType.ExecuteDefinitionRun;
  source: string;
  limit: boolean;
  selectedText?: string;
}

export interface ExecuteDefinitionRunFailedAction {
  type: SelectedDefinitionActionType.ExecuteDefinitionRunFailed;
  error: Error;
}

export interface CancelPollDefinitionRunAction {
  type: SelectedDefinitionActionType.CancelPollDefinitionRun;
}

export interface CancelDefinitionQueryRunAction {
  type: SelectedDefinitionActionType.CancelDefinitionQueryRun;
}

export interface CancelDefinitionQueryRunSuccessAction {
  type: SelectedDefinitionActionType.CancelDefinitionQueryRunSuccess;
  resource: QueryRunResource;
}

export interface CancelDefinitionQueryRunFailedAction {
  type: SelectedDefinitionActionType.CancelDefinitionQueryRunFailed;
  error: Error;
}

export interface PollDefinitionRunCompleteAction {
  type: SelectedDefinitionActionType.PollDefinitionRunComplete;
  token: string;
}

export interface DefinitionReportRunLoadSuccessAction {
  type: SelectedDefinitionActionType.DefinitionReportRunLoadSuccess;
  resource: ReportRunResource;
}

export interface DefinitionReportRunLoadFailureAction {
  type: SelectedDefinitionActionType.DefinitionReportRunLoadFailure;
  token: string;
  error: Error;
}

export interface LoadDefinitionQuerySuccessAction {
  type: SelectedDefinitionActionType.LoadDefinitionQuerySuccess;
  resource: QueryResource;
}

export interface LoadDefinitionQueryRunSuccess {
  type: SelectedDefinitionActionType.LoadDefinitionQueryRunSuccess;
  resource: QueryRunResource;
}

export interface LoadDefinitionQueryResultSuccess {
  type: SelectedDefinitionActionType.LoadDefinitionQueryResultSuccess;
  queryRun: QueryRunResource;
  resource: QueryResultResource;
  dataset?: DatasetResource;
  model?: Model;
  view?: FlamingoTypes.ModeView;
  queryResource: QueryResource;
}

export interface LoadDefinitionQueryResultFailureAction {
  type: SelectedDefinitionActionType.LoadDefinitionQueryResultFailure;
  queryRun: QueryRunResource;
}

export interface UpdateDefinitionSourceAction {
  type: SelectedDefinitionActionType.UpdateDefinitionSource;
  source: string;
}

export type DefinitionRunActions =
  | ManageDefinitionAction
  | UpdateDefinitionAction
  | UpdateDefinitionSuccessAction
  | UpdateDefinitionFailedAction
  | PollDefinitionRunAction
  | PollDefinitionRunFailedAction
  | DeleteDefinitionAction
  | DeleteDefinitionSuccessAction
  | DeleteDefinitionFailureAction
  | ExecuteDefinitionRunAction
  | ExecuteDefinitionRunFailedAction
  | CancelPollDefinitionRunAction
  | CancelDefinitionQueryRunAction
  | CancelDefinitionQueryRunSuccessAction
  | CancelDefinitionQueryRunFailedAction
  | PollDefinitionRunCompleteAction
  | DefinitionReportRunLoadSuccessAction
  | DefinitionReportRunLoadFailureAction
  | LoadDefinitionQuerySuccessAction
  | LoadDefinitionQueryRunSuccess
  | LoadDefinitionQueryResultSuccess
  | LoadDefinitionQueryResultFailureAction
  | UpdateDefinitionSourceAction;
